import StepLabel from '@mui/material/StepLabel';
import { styled } from '@mui/material/styles';

const StepIconRoot = styled('div')(({ ownerState }) => ({
  backgroundColor: 'unset',
  zIndex: 1,
  width: 20,
  height: 20,
  display: 'flex',
  borderRadius: '50%',
  border: '2px solid var(--trashie-ui-faded-black-30)',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    border: '2px solid var(--trashie-ui-faded-black-100-b)',
  }),
  ...(ownerState.completed && {
    border: '2px solid var(--trashie-ui-lime)',
    backgroundColor: 'var(--take-back-bags-lime)',
  }),
}));

const StepIcon = ({ active, completed, className }) => (
  <StepIconRoot ownerState={{ completed, active }} className={className}>
    {completed && (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M7.33301 10.2779L9.55523 12.5001L13.9997 8.05566" stroke="var(--trashie-ui-crisp-white)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )}
  </StepIconRoot>
);

const StyledStepLabel = styled((props) => (
  <StepLabel
    {...props}
    StepIconComponent={StepIcon}
  />
))({
  '& .MuiStepLabel-label': {
    color: 'var(--trashie-ui-faded-black-40)',
    fontFamily: 'GT Maru',
    fontSize: '10px',
    fontWeight: 500,
    lineHeight: '150%',
    '&.Mui-active': {
      color: 'var(--trashie-ui-faded-black-100-b)',
    },
    '&.Mui-completed': {
      color: 'var(--take-back-bags-lime)',
    },
    '&.MuiStepLabel-alternativeLabel': {
      marginTop: '4px',
    },
  },
});

export default StyledStepLabel;
